import { RouteComponentProps, withRouter } from 'react-router-dom'

import { branch, compose, renderComponent, withProps } from 'recompose'

import { SpendAccountStatus } from 'generated/types'
import { NonTrackedLoading } from 'pages/loading'

import withSpendCardStatus, {
  Props as CardStatusProps,
} from './withSpendCardStatus'

type Props = RouteComponentProps<{}> &
  CardStatusProps & {
    isWebView: boolean
  }

// Redirects user that has a closed spend account
// to the closed spend screen at /spend
const withSpendClosedRedirect = (redirect = '/spend') =>
  compose(
    withRouter,
    withProps(() => ({
      isWebView: window.location.pathname.startsWith('/wv/'),
    })),
    withSpendCardStatus(
      ({ cardStatusLoading, history, isWebView, spendAccount }: Props) => {
        if (
          !isWebView &&
          !cardStatusLoading &&
          spendAccount?.status === SpendAccountStatus.Closed &&
          // allow Spend reopens to access the signup page:
          !(
            spendAccount?.isReopenable &&
            window.location.pathname === '/spend/signup/address'
          )
        ) {
          history.replace(redirect)
        }
      },
    ),
    branch<Props>(
      ({ cardStatusLoading }) => cardStatusLoading,
      renderComponent(NonTrackedLoading),
    ),
  )

export default withSpendClosedRedirect
